import { useState, useEffect } from "react"
import {
  Modal,
  Form,
  Button,
  Row,
  Col,
  Tooltip,
  DatePicker,
  InputNumber,
  Input
} from "antd";
import styled from "styled-components";
import { useQueryClient } from 'react-query';
import URL from 'core/resources/urls';
import { showSuccess, showError } from "infra/helpers/alerta";
import { useAtualizarOrdemServicoTalhoes } from "../../../hooks/useGetHistoricoPlanejamentoOperacao";
import useModal from "../../../hooks/useModalPlanejamentoOperacoes";
import { SelectAntd } from "../styles";
import { useGetPlanoOperacionalRef } from "../../../hooks/useGetPlanoOperacionalRef";
import { FaSave } from "react-icons/fa";
import useAlvoDropdownList from "../../../hooks/useAlvoDropdownList";
import { useFilters } from "core/features/filters/store";
import { Planejamento } from "../../../interfaces/Planejamento";
import ModalVinculo from "../ModalVinculo";

interface ModalNovaOperacaoProps {
  refetch?: () => void;
  filtersData: any;
  planoOperacionalData: Planejamento
}

interface Referencia {
  codigo: string;
  codigoReferenciaPims: string;
  criacaoUsuarioId: string;
  dataCriacao: string;
  descricao: string;
  informarCarencia: boolean;
  informarOperacaoVinculada: boolean;
  informarPeriodo: boolean;
  planoOperacionalReferenciaId: string;
}

const { Item, useForm } = Form;

function ModalNovaOperacao({ filtersData, planoOperacionalData, refetch }: ModalNovaOperacaoProps) {
  const [referenciaRes, setReferenciaRes] = useState<Referencia | null>(null);
  const { mutateAsync: update, isLoading } = useAtualizarOrdemServicoTalhoes();
  const [range, setRange] = useState<string[]>();
  const [hasComponente, setHasComponente] = useState(false);
  const { fetchRef } = useGetPlanoOperacionalRef();
  const {
    talhaoId,
    setIds,
    isModalCadastroOperacao,
    setIsModalCadastroOperacao,
    isOpenModalVinculo,
    setIsOpenModalVinculo,
    operacaoVinculadaItem,
    setOperacaoVinculadaItem
  } = useModal();
  const [form] = useForm();
  const { RangePicker } = DatePicker;
  const { filters: { filtersAdvanced, unidade, safra } } = useFilters();
  const safraRes = planoOperacionalData?.filtrosAvancados?.safraPeriodos.find(plano => plano.safraPeriodoId === filtersAdvanced.safraPeriodo)
  const queryClient = useQueryClient();
  const { data: dropdownDataList } = useAlvoDropdownList({ OcupacaoId: safraRes?.ocupacaoId });

  const listMotivos = [
    { label: "Selecione um motivo", value: "" },
    { label: "Climático", value: 0 },
    { label: "Decisão Agronômica", value: 1 },
    { label: "Problema Operacional", value: 2 },
    { label: "Capacidade Operacional", value: 3 },
  ];

  useEffect(() => {
    form.setFieldsValue({
      doseporha: 1,
      utilizacao: 100
    });
  }, [isModalCadastroOperacao]);

  async function onFinish() {

    try {

      let dateStart: any = null;
      let dateEnd: any = null;

      if (range && range.length > 0) {
        const [start, end] = range;
        const startISO = start
          ? start.split('/').reverse().join('-')
          : null;
        const endISO = end
          ? end.split('/').reverse().join('-')
          : null;

        dateStart = startISO;
        dateEnd = endISO;

      }

      let sequencia = 1;
      if (operacaoVinculadaItem?.operacao_planoOperacionalOperacaoId) {
        sequencia = operacaoVinculadaItem?.sequencia + 1;
      }

      let payload = {
        talhaoId,
        unidadeId: unidade?.id,
        safraId: safra?.id,
        safraPeriodoId: filtersAdvanced.safraPeriodo,
        ocupacaoId: safraRes?.ocupacaoId,
        observacao: form.getFieldValue('observacao'),
        motivo: form.getFieldValue('motivo'),
        planoOperacionalOperacoes: [{
          sequencia,
          operacaoId: form.getFieldValue('operacao'),
          planoOperacionalReferenciaId: form.getFieldValue('referencia'),
          planoOperacionalOperacaoReferenciaId: operacaoVinculadaItem?.operacao_planoOperacionalOperacaoId,
          carenciaQuantidadeDias: form.getFieldValue('carencia'),
          periodoDataInicio: dateStart,
          periodoDataFim: dateEnd,
          componentes: !hasComponente ? [] : [{
            componenteId: form.getFieldValue('componente'),
            quantidade: form.getFieldValue('doseporha'),
            porcentagemUtilizacao: form.getFieldValue('utilizacao'),
            alvos: form.getFieldValue('alvo') ? form.getFieldValue('alvo') : [],
          }]
        }]
      }

      let response: any = await update({ body: payload });

      if (response.status === 204) {
        showSuccess("Operação criada com sucesso!");
        queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_LISTA_POR_TALHAO, talhaoId, { safraPeriodoId: filtersAdvanced.safraPeriodo }]);
        queryClient.invalidateQueries([URL.PLANO_OPERACIONAL.OBTER_HISTORICO_TALHAO_ORDEM_SERVICO, talhaoId]);
        closedModal();
        return;
      }
      const details = (response as any).response.data.Details;
      const error = details[0].Errors[0];
      showError(error);
    } catch (error) {
      showError('Não foi possivel criar a Operação');
    }
  }

  function closedModal() {
    setIsModalCadastroOperacao(false);
    setIds([]);
    form.resetFields();
  }

  return (
    <CustomModal
      title="Nova Operação"
      visible={isModalCadastroOperacao}
      onCancel={closedModal}
      width="70%"
      maskClosable={false}
      className="teste"
      modalRender={(dom) => (
        <div style={{ position: "relative" }}>
          {isOpenModalVinculo && <div className="inner-overlay" />}
          {dom}
        </div>
      )}
      footer={
        <>
          <Button
            size="large"
            loading={isLoading}
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Cancelar</Button>
          <ButtonStyled
            size="large"
            type="primary"
            loading={isLoading}
            onClick={() => form.submit()}
            icon={<FaSave />}
          >Salvar Planejamento</ButtonStyled>
        </>
      }
    >
      <div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Item
                label="Operação"
                name="operacao"
                rules={[{ required: true, message: "Campo Operação é obrigatório" }]}
              >
                <SelectAntd
                  showSearch
                  placeholder="Selecione uma operação"
                  optionFilterProp="label"
                  options={filtersData?.operacoesList?.map((item: any) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                />
              </Item>
            </Col>
            <Col span={5}>
              <Item
                label="Referência"
                name="referencia"
                rules={[{ required: true, message: "Campo Referencia é obrigatório" }]}
              >
                <SelectAntd
                  showSearch
                  placeholder="Selecione uma referencia"
                  onChange={async (label: any) => {
                    try {
                      const data: Referencia = await fetchRef(label);
                      setReferenciaRes(data);
                      form.setFieldsValue({ carencia: "", periodoData: "" });
                      setRange(['', '']);
                      setOperacaoVinculadaItem(null);

                      if (data?.informarOperacaoVinculada) {
                        setIsOpenModalVinculo(true);
                      }
                    } catch (err) {
                      console.error("Erro ao buscar referência:", err);
                    }
                  }}
                  optionFilterProp="label"
                  options={[
                    {
                      label: "Selecione uma Referência",
                      value: "",
                    },
                    ...(filtersData?.referenciasList?.map((item: any) => ({
                      label: item.text,
                      value: item.value,
                    })) || []),
                  ]}
                />
              </Item>
            </Col>
            {
              referenciaRes?.informarCarencia && (
                <Col span={3}>
                  <Item
                    label="Carência"
                    name="carencia"
                    rules={[{ required: true, message: "Campo Carencia é obrigatório" }]}
                  >
                    <InputNumberStyled
                      height="2.5rem"
                      type="number"
                      placeholder="Carencia"
                      style={{ borderRadius: '0.375rem', textAlign: 'center' }}
                    />
                  </Item>
                </Col>
              )
            }
            {
              referenciaRes?.informarPeriodo && (
                <Col span={6}>
                  <Item
                    label="Informe o período"
                    name="periodoData"
                    rules={[{ required: true, message: "Campo período é obrigatório" }]}
                  >
                    <RangePicker
                      allowClear={true}
                      format="DD/MM/YYYY"
                      style={{ width: "100%", height: 40, borderRadius: "8px" }}
                      onCalendarChange={(_, dateStrings) => {
                        if (!dateStrings) return;
                        setRange(dateStrings);
                      }}
                    />
                  </Item>
                </Col>
              )
            }
            {
              referenciaRes?.informarOperacaoVinculada && operacaoVinculadaItem && (
                <Col span={3} style={{ transform: "translate(6px, 34px)" }}>
                  <VinculoLink onClick={() => {
                    setIsOpenModalVinculo(true);
                  }}>Operação {operacaoVinculadaItem?.index}</VinculoLink>
                </Col>
              )
            }
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Item
                label="Componente"
                name="componente"
              >
                <SelectAntd
                  showSearch
                  placeholder="Selecione um componente"
                  optionFilterProp="label"
                  allowClear
                  options={filtersData?.dataComponente?.map((item: any) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  onChange={(value) => {
                    setHasComponente(!!value);

                    if (!value) {
                      form.setFieldsValue({ doseporha: undefined });
                      form.setFieldsValue({ utilizacao: undefined });
                      form.setFields([
                        {
                          name: 'doseporha',
                          errors: [],
                        },
                        {
                          name: 'utilizacao',
                          errors: [],
                        },
                      ]);
                    }
                  }}
                  onClear={() => {
                    form.setFieldsValue({ doseporha: undefined });
                    form.setFieldsValue({ utilizacao: undefined });
                    form.setFields([
                      {
                        name: 'doseporha',
                        errors: [],
                      },
                      {
                        name: 'utilizacao',
                        errors: [],
                      },
                    ]);
                  }}
                />
              </Item>
            </Col>
            <Col span={3}>
              <Item
                label="Dose por ha"
                name="doseporha"
                rules={[
                  ...(hasComponente
                    ? [{ required: true, message: "Campo Dose por ha é obrigatório" }]
                    : []),
                  { type: "number", min: 0.1, message: "O valor mínimo é 0.1" },
                ]}
              >
                <InputNumberStyled
                  height="2.5rem"
                  placeholder="dose"
                  min={0.1}
                  defaultValue={1}
                  disabled={!hasComponente}
                  style={{ borderRadius: '0.375rem', textAlign: 'center' }}
                />
              </Item>
            </Col>
            <Col span={3}>
              <Item
                label="% Utilização"
                name="utilizacao"
                rules={[
                  ...(hasComponente
                    ? [{ required: true, message: "Campo Utilização por ha é obrigatório" }]
                    : []),
                  { type: "number", min: 0.1, message: "O valor mínimo é 0.1" },
                  { type: "number", max: 100, message: "O valor máximo é 100" },
                ]}
              >
                <InputNumberStyled
                  height="2.5rem"
                  placeholder="utilizacao"
                  style={{ borderRadius: '0.375rem', textAlign: 'center' }}
                  maxLength={3}
                  defaultValue={100}
                  disabled={!hasComponente}
                  type="number"
                />
              </Item>
            </Col>
            <Col span={10}>
              <Item
                label="Alvo"
                name="alvo"
              >
                <SelectAntd
                  showSearch
                  placeholder="Selecione um alvo"
                  mode="multiple"
                  maxTagCount="responsive"
                  style={{ width: "100%" }}
                  disabled={!hasComponente}
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      title={omittedValues.map((v) => v.label).join(", ")}
                      placement="top"
                    >
                      +{omittedValues.length} itens
                    </Tooltip>
                  )}
                  optionFilterProp="label"
                  options={dropdownDataList?.map((item: any) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                />
              </Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Item
                label="Motivo"
                name="motivo"
                rules={[{ required: true, message: "Campo Motivo é obrigatório" }]}
              >
                <SelectAntd
                  options={listMotivos.map((item: any) => ({
                    label: item.label,
                    value: item.value,
                  }))}
                />
              </Item>
            </Col>
            <Col span={10}>
              <Item
                label="Observação"
                name="observacao"
                rules={[{ required: true, message: "Campo Observação é obrigatório" }]}
              >
                <Input
                  size="large"
                  placeholder="Observação"
                  style={{ borderRadius: 8 }}
                  maxLength={200}
                />
              </Item>
            </Col>
          </Row>
        </Form>
      </div>
      <ModalVinculo form={form} />
    </CustomModal>
  );
}

const InputNumberStyled = styled(InputNumber)`
  height: 2.5rem;
  padding: 0.2rem;
`;

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

   .ant-form-item-required::before {
    content: none !important;
  }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

export const ButtonStyled = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #11a557;
  border: none;

  &:hover, &:active, &:focus {
    background-color: #0e8a47;
  }
`

export const VinculoLink = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  background: #E3F2FD;
  border: 1px solid #2196F3;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  color: #1976D2;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export default ModalNovaOperacao;
